import React, { useEffect } from "react";
import "../styles/layout.css";

const Toast = ({ message, type = "info", onClose }) => {
  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, [message]);

  if (!message) return null;

  return (
    <div className="toast-viewport" role="status" aria-live="polite">
      <div className={`toast-box toast-${type}`}>
        <div className="toast-content">
          <span>{message}</span>

          <button
            className="toast-close"
            type="button"
            aria-label="Cerrar notificación"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast;
